import { EMPTY_STRING } from "../../constants/emptyString";

/**
 * Adds an ellipsis to the end of a string.
 */
export function stringEllipsize(value: string): string {
  return value.length === 0 ? EMPTY_STRING : `${value}...`;
}
